"use strict";
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectingPopup = void 0;
const Popup_1 = require("./Popup");
const pixi_js_1 = require("pixi.js");
const Block_1 = require("../blocks/Block");
const Global_1 = require("../Global");
const WaitingText_1 = require("../objects/WaitingText");
const ui_1 = require("@pixi/ui");
const settings_1 = require("../config/settings");
class ConnectingPopup extends Popup_1.Popup {
    constructor(app) {
        super(app);
        this.ticker = new pixi_js_1.Ticker();
        this.info = this.makeInfo();
        this.loader = this.makeLoading();
    }
    get backgroundsettings() {
        const info = super.backgroundsettings;
        info.backgroundColor = settings_1.Settings.unavailableColor;
        return info;
    }
    makeLoading() {
        const bar = new ui_1.CircularProgressBar({
            backgroundColor: settings_1.Settings.darkGrayColor,
            lineWidth: (0, Global_1.px)(8),
            fillColor: settings_1.Settings.whiteColor,
            radius: (0, Global_1.px)(30),
            value: 0,
            backgroundAlpha: 1,
            fillAlpha: 1,
            cap: 'round'
        });
        let isFilling = true;
        this.ticker.speed = 0.7;
        this.ticker.add((deltaTime) => {
            let value = bar.progress;
            if (isFilling) {
                value += deltaTime;
            }
            else {
                value -= deltaTime;
            }
            if (value >= 100) {
                isFilling = false;
            }
            else if (value <= 0) {
                isFilling = true;
            }
            bar.progress = value;
            bar.rotation += deltaTime / 10;
        });
        this.ticker.start();
        return this.addChild(bar);
    }
    makeInfo() {
        const style = Block_1.Block.textStyle(30, false);
        style.fill = settings_1.Settings.whiteColor;
        style.wordWrap = true;
        style.wordWrapWidth = this.background.width;
        style.align = 'center';
        const info = new WaitingText_1.WaitingText("Connecting to Server", style);
        info.anchor.set(0.5);
        return this.addChild(info);
    }
    destroy(_options) {
        super.destroy(_options);
        this.ticker.destroy();
    }
    layout() {
        super.layout();
        this.info.position.set(this.center.x, this.center.y + (0, Global_1.px)(40));
        this.loader.position.set(this.center.x, this.center.y - (0, Global_1.px)(40));
    }
}
exports.ConnectingPopup = ConnectingPopup;
